import GlyphChoiceButton from "./GlyphChoiceButton";

export default function MultiPartWidget({
  parts = [],
  value = {},
  onChange,
  mode,
  feedback
}) {
  const showFeedback = Boolean(feedback?.parts);

  function setPart(idx, v) {
    if (mode !== "edit" || showFeedback) return;
    onChange({ ...value, [idx]: v });
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {parts.map((p, i) => {
        const selected = value?.[i];
        const partFeedback = feedback?.parts?.[i];
        const expected = partFeedback?.expected;

        return (
          <div key={i} style={{ marginLeft: 16 }}>
            <p style={{ fontWeight: 500, marginBottom: 8 }}>
              ({String.fromCharCode(97 + i)}) {p.prompt}
            </p>

            {/* ───────── GLYPH CHOICE ───────── */}
            {p.type === "glyph-choice" && Array.isArray(p.options) && (
              <div style={{ display: "flex", gap: 16, marginLeft: 16 }}>
                {p.options.map((opt) => {
                  // const isCorrect =
                  //   showFeedback && opt.value === expected;

                  // const isWrong =
                  //   showFeedback &&
                  //   selected === opt.value &&
                  //   opt.value !== expected;
                  const isCorrect =
                    showFeedback &&
                    selected === opt.value &&
                    partFeedback?.correct === true;

                  const isWrong =
                    showFeedback &&
                    selected === opt.value &&
                    partFeedback?.correct === false;

                  return (
                    <GlyphChoiceButton
                      key={opt.value}
                      symbol={opt.symbol}
                      selected={!showFeedback && selected === opt.value}
                      correct={isCorrect}
                      wrong={isWrong}
                      onClick={() => setPart(i, opt.value)}
                      disabled={mode !== "edit" || showFeedback}
                    />
                  );
                })}
              </div>
            )}

            {/* ───────── TEXT CHOICE ───────── */}
            {p.type === "text-choice" && Array.isArray(p.options) && (
              <div style={{ display: "flex", gap: 12, marginLeft: 16 }}>
                {p.options.map((opt) => {
                  // const isCorrect =
                  //   showFeedback && opt === expected;

                  // const isWrong =
                  //   showFeedback &&
                  //   selected === opt &&
                  //   opt !== expected;
                  const isCorrect =
                    showFeedback &&
                    selected === opt &&
                    partFeedback?.correct === true;

                  const isWrong =
                    showFeedback &&
                    selected === opt &&
                    partFeedback?.correct === false;

                  return (
                    <button
                      key={opt}
                      onClick={() => setPart(i, opt)}
                      disabled={mode !== "edit" || showFeedback}
                      style={{
                        cursor:
                          mode === "edit" && !showFeedback
                            ? "pointer"
                            : "default",
                        padding: "6px 14px",
                        fontSize: 16,
                        fontWeight: 600,
                        borderRadius: 999,
                        background: "white",
                        border: "2px solid",
                        borderColor: isCorrect
                          ? "#2e7d32"
                          : isWrong
                          ? "#c62828"
                          : !showFeedback && selected === opt
                          ? "#000"
                          : "#ccc"
                        // border: isCorrect
                        //   ? "2px solid green"
                        //   : isWrong
                        //   ? "2px solid red"
                        //   : !showFeedback && selected === opt
                        //   ? "2px solid black"
                        //   : "1px solid #ccc"
                      }}
                    >
                      {opt}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
